export default __webpack_public_path__ + "static/media/dashboard.0243fe00.svg";